import { splitProps, type Component, type JSX } from "solid-js";

export type ChipVariant = "neutral" | "conforming" | "partial" | "non-conforming" | "attention";

export interface AplombChipProps extends JSX.HTMLAttributes<HTMLSpanElement> {
  variant?: ChipVariant;
  compact?: boolean;
}

export const AplombChip: Component<AplombChipProps> = (rawProps) => {
  const [local, rest] = splitProps(rawProps, ["variant", "compact", "children", "class"]);
  const variant = () => local.variant ?? "neutral";
  return (
    <span
      class={`a-chip a-chip--${variant()}${local.compact ? " a-chip--compact" : ""}${local.class ? ` ${local.class}` : ""}`}
      {...rest}
    >
      {local.children}
    </span>
  );
};
